import { useAssignReferenceIndex } from 'stores/useReferenceMapsStore'

import { addCustomElements } from 'utils/addCustomElements'
import { getSanitizedContent } from 'utils/getSanitizedContent'

import type { GetSanitizedContentWithCustomElementsInput } from 'types/GetSanitizedContentWithCustomElementsInput'

export const useSanitizedContentWithCustomElements = () => {
  const assignReferenceIndex = useAssignReferenceIndex()

  const getSanitizedContentWithCustomElements = ({
    markdownContent,
    messageId,
    outputFormat,
  }: GetSanitizedContentWithCustomElementsInput): string | null => {
    if (!markdownContent) return null

    const sanitizedContent = getSanitizedContent(markdownContent)

    const sanitizedContentWithCustomElements = addCustomElements({
      assignReferenceIndex,
      markdownContent: sanitizedContent,
      messageId,
      outputFormat,
    })

    return sanitizedContentWithCustomElements
  }

  return getSanitizedContentWithCustomElements
}
